import React, { useContext } from 'react';
import { IEditComboGroupContext, EditComboGroupContext } from '../../../editComboGroupState/editComboGroupContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setDefaultCustomerLanguage,
		setTranslationTab,
		changeNameTranslation,
		selectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<IEditComboGroupContext>(EditComboGroupContext);
	return (
		<MenuTranslationForm
			setDefaultCustomerLanguage={setDefaultCustomerLanguage}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={selectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
